import { frontendURL } from '../../../../helper/URLHelper';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const IAAgentHome = () => import('./Index.vue');
const AddIAAgent = () => import('./AddIAAgent.vue');
const EditIAAgent = () => import('./EditIAAgent.vue');
const AddKnowledgeSource = () => import('./AddKnowledgeSource.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ia-agents'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'ia_agent_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'ia_agent_list',
          component: IAAgentHome,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'new',
          name: 'ia_agent_new',
          component: AddIAAgent,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':id/edit',
          name: 'ia_agent_edit',
          component: EditIAAgent,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':id/add-knowledge',
          name: 'ia_agent_add_knowledge',
          component: AddKnowledgeSource,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
}; 